import {
  QuickFilterAlias,
  QuickFilterParameter,
  QuickFilterParameterName,
  RequestQuickFilters
} from '@/api/models/requests/lib/requests.types'

export const findQuickFilterByAlias = (
  alias: QuickFilterAlias,
  filters?: RequestQuickFilters[] | null
): RequestQuickFilters | undefined => {
  return filters?.find(filter => filter.alias === alias)
}

export const transformQuickFilterParams = (
  parameters?: QuickFilterParameter[]
): Record<QuickFilterParameterName, string[]> | undefined => {
  if (!parameters) {
    return undefined
  }

  return parameters.reduce(
    (acc, { name, data }) => {
      acc[name] = data
      return acc
    },
    {} as Record<QuickFilterParameterName, string[]>
  )
}
